import React, { Component } from "react";
import Poules from "../../components/structure/Poules";
import TeamsNotDivided from "../../components/structure/TeamsNotDivided";
import PouleContainer from "../../containers/structure/PouleContainer";
import BracketContainer from "../../containers/structure/BracketContainer";
// import UpgradeDialog from "../../components/UpgradeDialog";
// import { languages } from "../../constants/languages";
import { Draggable } from "react-beautiful-dnd";
import { moveTeamToPouleSpot } from "../../util/MoveTeamToPouleSpot";

class FaseContainer extends Component {
  state = {
    anchorEl: null,
    selectedTeam: {},
    menuClickEnabled: true,
    // upgradeDialogOpen: false,
    structureObjectsTemp: undefined,
  };

  setStructureObjectsTemp = (structureObjects) => {
    this.setState({ structureObjectsTemp: structureObjects });
  };

  // toggleUpgradeDialog = () => {
  //   if (!this.state.upgradeDialogOpen) {
  //     // mailer lite paywall seen
  //     window.firebase
  //       .firestore()
  //       .collection("paywallSeenRequests")
  //       .doc()
  //       .set({ uid: this.props.user.uid });
  //   }
  //   this.setState({ upgradeDialogOpen: !this.state.upgradeDialogOpen });
  // };

  handleClickPouleSpot = (event, team) => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({
        anchorEl: event.currentTarget,
        selectedTeam: team,
        menuClickEnabled: true,
      });
    }
  };

  handleMenuItemClick = (event, team) => {
    if (this.state.menuClickEnabled) {
      this.setState({ anchorEl: null, menuClickEnabled: false });

      let newTeamId = null;
      if (team && team !== "bye" && team !== "noShow") {
        newTeamId = team.id;
      }

      const oldTeam = this.state.selectedTeam;

      const db = window.firebase.firestore();

      let batch = db.batch();

      batch = moveTeamToPouleSpot(
        batch,
        newTeamId,
        this.state.selectedTeam["poule" + this.props.fase],
        this.state.selectedTeam["numInPoule" + this.props.fase],
        oldTeam,
        team === "bye" || team === "noShow" ? team : null,
        team && team.resultSpot,
        this.props.tournament,
        this.props.poulesByKey,
        this.props.bracketsByKey,
        this.props.resultSpotsAll,
        this.props.teams,
        this.props.fase
      );

      if (this.props.tournament.ia) {
        batch.set(db.collection("cacheUpdatesApp").doc(), {
          tournamentId: this.props.tournament[".key"],
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
      }

      if (newTeamId && !team.resultSpot) {
        if (
          this.props.numDivided - (!oldTeam.empty ? 1 : 0) >=
          this.props.maxTeams
        ) {
          if (window.firebase.analytics) {
            window.firebase.analytics().logEvent("max_teams_divided", {
              max_teams: this.props.maxTeams.toString(),
            });
          }
          this.props.toggleUpgradeDialog();
        } else {
          batch.commit();
        }
      } else {
        batch.commit();
      }
    }
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  getPouleElement = (poule, i) => {
    return (
      <Draggable key={poule.id} draggableId={poule.id} index={i}>
        {(provided, snapshot) => (
          <div>
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              <PouleContainer
                tournament={this.props.tournament}
                divisionsObject={this.props.divisionsObject}
                division={this.props.division}
                poule={poule}
                handleClickPouleSpot={this.handleClickPouleSpot}
                resultSpotsNotDivided={this.props.resultSpotsAll.filter(
                  (resultSpot) => resultSpot.fromPoule === poule.id
                )}
                resultSpotsAll={this.props.resultSpotsAll}
                fase={this.props.fase}
                faseStarted={this.props.faseStarted}
                poulesByKey={this.props.poulesByKey}
                toggleResultSpotType={this.toggleResultSpotType}
                bracketsByKey={this.props.bracketsByKey}
                userStatus={this.props.userStatus}
                tournamentStatus={this.props.tournamentStatus}
                toggleFinishedDialog={this.props.toggleFinishedDialog}
                user={this.props.user}
                daysByKey={this.props.daysByKey}
                toggleUpgradeDialog={this.props.toggleUpgradeDialog}
              />
            </div>
            {provided.placeholder}
          </div>
        )}
      </Draggable>
    );
  };

  getDraggableBracketElement = (bracket, i) => {
    return (
      <Draggable key={bracket.id} draggableId={bracket.id} index={i}>
        {(provided, snapshot) => (
          <div>
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              <div>{this.getBracketElement(bracket)}</div>
            </div>
            {provided.placeholder}
          </div>
        )}
      </Draggable>
    );
  };

  getBracketElement = (bracket) => {
    return (
      <div key={bracket.id}>
        <BracketContainer
          tournament={this.props.tournament}
          divisionsObject={this.props.divisionsObject}
          division={this.props.division}
          bracket={bracket}
          handleClickPouleSpot={this.handleClickPouleSpot}
          resultSpotsAll={this.props.resultSpotsAll}
          fase={this.props.fase}
          faseStarted={this.props.faseStarted}
          poules={this.props.poules.filter(
            (poule) => poule.bracket === bracket.id
          )}
          poulesByKey={this.props.poulesByKey}
          toggleResultSpotType={this.toggleResultSpotType}
          allPoules={this.props.poules}
          allBrackets={this.props.brackets}
          bracketsByKey={this.props.bracketsByKey}
          subBrackets={(this.props.subBrackets[bracket.id] || [])
            .sort((a, b) => a.num - b.num)
            .map((bracket) => this.getBracketElement(bracket))}
          subBracketsArray={this.props.subBrackets[bracket.id] || []}
          allBracketsForPhase={this.props.allBracketsForPhase}
          userStatus={this.props.userStatus}
          tournamentStatus={this.props.tournamentStatus}
          toggleFinishedDialog={this.props.toggleFinishedDialog}
          daysByKey={this.props.daysByKey}
          toggleUpgradeDialog={this.props.toggleUpgradeDialog}
          user={this.props.user}
        />
      </div>
    );
  };

  toggleResultSpotType = (e, fase, rank) => {
    const resultSpots = this.props.resultSpotsAll.filter(
      (resultSpot) => resultSpot.fase === fase && resultSpot.rank === rank
    );
    const db = window.firebase.firestore();

    const batch = db.batch();

    const resultSpotsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("resultSpots");

    let newType = 1;
    if ((resultSpots[0] || {}).type === 1) {
      newType = 0;
    }
    for (let i in resultSpots) {
      const resultSpot = resultSpots[i];
      const resultSpotRef = resultSpotsRef.doc(resultSpot.id);

      batch.update(resultSpotRef, { type: newType });
    }
    batch.commit();
  };

  render() {
    let teamsNotDivided = this.props.resultSpotsNotDivided.filter(
      (resultSpot) =>
        resultSpot.fase < this.props.fase && !resultSpot.belongsToBracket
    );
    if (this.props.fase === 0) {
      teamsNotDivided = this.props.teamsNotDivided.concat(teamsNotDivided);
    } else {
      teamsNotDivided = teamsNotDivided.concat(this.props.teamsNotDivided);
    }

    let objectElements = [],
      i = 0,
      j = 0;

    let poules = this.props.poules.filter((poule) => poule.bracket === null);
    let brackets = this.props.brackets;

    while (i < poules.length && j < brackets.length) {
      if (poules[i].num <= brackets[j].num) {
        const poule = poules[i];
        objectElements.push(poule);
        // const pouleElement = this.getPouleElement(poule);
        // elements.push(pouleElement);
        i++;
      } else {
        const bracket = brackets[j];
        objectElements.push(bracket);
        // const bracketElement = this.getBracketElement(bracket);
        // elements.push(bracketElement);
        j++;
      }
    }
    // const structureElements = elements
    //   .concat(poules.slice(i).map((poule) => this.getPouleElement(poule)))
    //   .concat(
    //     brackets.slice(j).map((bracket) => this.getBracketElement(bracket))
    //   );

    const structureObjects = objectElements
      .concat(poules.slice(i))
      .concat(brackets.slice(j));

    const structureElements = (
      this.state.setStructureObjectsTemp
        ? this.state.setStructureObjectsTemp
        : structureObjects
    )
      .slice()
      .sort((a, b) => {
        if (a.indexNum > b.indexNum) {
          return 1;
        } else if (a.indexNum < b.indexNum) {
          return -1;
        } else if (a.num > b.num) {
          return 1;
        } else if (a.num < b.num) {
          return -1;
        } else {
          return 0;
        }
      })
      .map((o, i) => {
        if (o.size) {
          return this.getDraggableBracketElement(o, i);
        } else {
          return this.getPouleElement(o, i);
        }
      });

    return (
      <div style={{ display: "inline-block" }}>
        <TeamsNotDivided
          tournament={this.props.tournament}
          divisionsObject={this.props.divisionsObject}
          teams={teamsNotDivided}
          anchorEl={this.state.anchorEl}
          selectedTeam={this.state.selectedTeam}
          handleClose={this.handleClose}
          handleMenuItemClick={this.handleMenuItemClick}
          poulesByKey={this.props.poulesByKey}
          bracketsByKey={this.props.bracketsByKey}
          toggleResultSpotType={this.toggleResultSpotType}
          resultSpotsAll={this.props.resultSpotsAll}
          numTeams={this.props.teams.length}
          fase={this.props.fase}
          division={this.props.division}
        />
        <Poules
          tournament={this.props.tournament}
          division={this.props.division}
          poules={this.props.poules}
          handleClickPouleSpot={this.handleClickPouleSpot}
          resultSpotsNotDivided={this.props.resultSpotsNotDivided}
          resultSpotsAll={this.props.resultSpotsAll}
          fase={this.props.fase}
          faseObject={this.props.faseObject}
          faseStarted={this.props.faseStarted}
          poulesByKey={this.props.poulesByKey}
          allBracketsForPhase={this.props.allBracketsForPhase}
          brackets={this.props.brackets}
          subBrackets={this.props.subBrackets}
          bracketsByKey={this.props.bracketsByKey}
          structureElements={structureElements}
          userStatus={this.props.userStatus}
          tournamentStatus={this.props.tournamentStatus}
          toggleFinishedDialog={this.props.toggleFinishedDialog}
          user={this.props.user}
          teams={this.props.teams}
          structureObjects={structureObjects}
          maxTeams={this.props.maxTeams}
          toggleUpgradeDialog={this.props.toggleUpgradeDialog}
          setStructureObjectsTemp={this.setStructureObjectsTemp}
        />
        {/* <UpgradeDialog
          open={this.state.upgradeDialogOpen}
          toggleDialog={this.toggleUpgradeDialog}
          title={languages.upgrade.upgradeTournament}
          description={languages.upgrade.upgradeText1}
          tournament={this.props.tournament}
          user={this.props.user}
          structurePage
          maxTeams={this.props.maxTeams}
          userData={this.props.userData}
        /> */}
      </div>
    );
  }
}

export default FaseContainer;
